import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c54a484"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-4 py-lg-5" }
const _hoisted_2 = { class: "mx-2" }
const _hoisted_3 = { class: "fs-7 p-3 mb-5 rounded-1 while-spaces" }

import Button from '@/components/button/index.vue'
import { useRouter, useRoute } from 'vue-router'
import { translate } from '@/languages/i18n'
import { getMessage } from '@/constants/messageCode.ts'
import { ref, onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()

const message = ref<string>('')
onMounted(() => {
  message.value = route.query?.message_code
})

const redirectLogin = () => {
  if (route.path.match(`/alumni`)) {
    router.push('/alumni/login')
  } else if (route.path.match(`/community`)) {
    router.push('/community/users/login')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(getMessage)(message.value)), 1)
    ])
  ]))
}
}

})